<template>
  <div>
    <div class="filters-items" id="filters-items">
      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter1"
          aria-expanded="false"
          aria-controls="category"
        >Categorias</button>

        <div id="filter1" class="collapse" aria-labelledby="filter1" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="category in categories"
              :key="category"
              v-if="!selectedFilters.category.value || selectedFilters.category.value === category"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="category"
                :id="category"
                :true-value="category"
                :false-value="''"
                v-model="selectedFilters.category.value"
                @change="clearNext(1), getFilters()"
              >
              <label class="form-check-label" :for="category">{{category}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter2"
          aria-expanded="false"
          aria-controls="category"
        >Fabricantes</button>
        <div id="filter2" class="collapse" aria-labelledby="filter2" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="manufacturer in manufacturers"
              :key="manufacturer"
              v-if="!!selectedFilters.category.value && !selectedFilters.manufacturer.value || selectedFilters.manufacturer.value === manufacturer"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="manufacturer"
                :id="manufacturer"
                :true-value="manufacturer"
                :false-value="''"
                @change="clearNext(2), getFilters()"
                v-model="selectedFilters.manufacturer.value"
              >
              <label class="form-check-label" :for="manufacturer">{{manufacturer}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter3"
          aria-expanded="false"
          aria-controls="category"
        >Modelos</button>
        <div id="filter3" class="collapse" aria-labelledby="filter3" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="model in models"
              :key="model"
              v-if="!!selectedFilters.manufacturer.value && !selectedFilters.model.value || selectedFilters.model.value === model"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="model"
                :id="model"
                :true-value="model"
                :false-value="''"
                @change="getFilters()"
                v-model="selectedFilters.model.value"
              >
              <label class="form-check-label" :for="model">{{model}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="m-4 text-center">
        <a href="https://static.japanparts.com.br/Japanparts-2017-2018.zip" class="btn btn-primary">
          <i class="icon-document-download"></i> Catálogo
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { sortArrayOfStringAlphabetically } from "@/utils/array.js";

export default {

  data() {
    return {
      selectedFilters: {
       category: { name: 'category', value: '' },
       model: { name: 'model', value: '' },
       manufacturer: { name: 'manufacturer', value: '' }
      },

      categories: [],
      models: [],
      manufacturers: [],

      filters: [
        'category',
        'manufacturer',
        'model',
      ]
    };
  },
  props: {
    branchedFilters: {
      type: Object,
      default: {}
    },
    filtersFromUrl: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    'selectedFilters.category.value': function() {
      if (this.selectedFilters.category.value) {
        this.manufacturers = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.category.value]);
      }
    },

    'selectedFilters.manufacturer.value': function(filter) {
      if (filter) {
        this.models = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.category.value][filter]);
      }
    }
  },
  mounted() {
    this.getCategories();
    this.loadSelectedFIltersFromURL()
  },
  methods: {
    getFilters() {
      const formattedFilters = {
        category: this.selectedFilters.category.value,
        model: this.selectedFilters.model.value,
        manufacturer: this.selectedFilters.manufacturer.value,
      }

      const filters = [
        this.selectedFilters.category.value,
        this.selectedFilters.model.value,
        this.selectedFilters.manufacturer.value,
      ].filter(filter => !!filter);

      this.$emit('update:selectedPartFilters', formattedFilters);
      this.$emit('update:listPartFilters', filters);
    },

    loadSelectedFIltersFromURL() {
      for (let [filterKey, filterObject] of Object.entries(this.selectedFilters)) {
        const foundFilter = this.filtersFromUrl.find(filter => filter.name === filterObject.name)

        if (foundFilter) {
          this.selectedFilters[filterKey].value = foundFilter.value;
        }
      }
      this.getFilters();
    },

    getCategories() {
      this.categories = this.filterInvalidValues(this.branchedFilters);
    },

    clearNext(from) {
      this.clearFields(this.filters.slice(from));
    },

    clearFields(toRemove) {
      for (let [filterKey, filter] of Object.entries(this.selectedFilters)) {
        if (toRemove.includes(filter.name)) {
          this.selectedFilters[filterKey].value = '';
        }
      }
    },

    filterInvalidValues(filters) {
      const filteredFilters = Object.keys(filters).filter(filter => !!filter && filter !== 'null')
      return sortArrayOfStringAlphabetically(filteredFilters);
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PartFilters.vue